const Form065EN = {
    stepName: {
        importantNotes: "Important Notes",
        information: "Basic Information",
        section1: "Section I",
        section2: "Section II",
        section3: "Section III",
        // toBeCompletedByTheSchool: "To be completed by the school",
        // confirm: "Confirm",
        confirmation: "Confirmation",
    },
    label: {
        conditionsCheck:
            // "I have read and understood the “Personal Information Collection Statement”.",
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        iamStatement:
            // "I understood that digital signature through “iAM Smart+” is required on this fillable form for e-submission. ",
            "I understand that an “iAM Smart+” account is required for processing the application.",
        information: {
            noteList: {
                note1: "Please read the Personal Information Collection Statement carefully before completing this form.",
                note2: "Please ensure the content of this form is made known to the teacher and he/she has read the Personal Information Collection Statement.",
                note3: "For enquiries in completing this form, please contact the respective School Development Officers.",
            },
            note: {
                note: "Notes",
                // note1: "Please read the attached Personal Information Collection Statement carefully before completing this form.",
                // note2: "Please ensure the content of this form is made known to the teacher and he/she has read the attached Personal Information Collection Statement.",
                // note3: "For enquiries in completing this form, please contact the respective School Development Officers.",
            },
            ssdoOption: {
                Central_and_Western: "Central & Western District",
                Southern: "Southern District",
                Wan_Chai: "Wan Chai District",
                Islands: "Islands District",
                HKEast: "Hong Kong East District",
                Kowloon_City: "Kowloon City District",
                Sham_Shui_Po: "Sham Shui Po District",
                Sai_Kung: "Sai Kung District",
                Kwun_Tong: "Kwun Tong District",
                Wong_Tai_Sin: "Wong Tai Sin District",
                Yau_Tsim_Mong: "Yau Tsim & Mong Kok District",
                Tai_Po: "Tai Po District",
                North: "North District",
                Sha_Tin: "Sha Tin District",
                Kwai_Chung_and_Tsing_Yi: "Kwai Chung & Tsing Yi District",
                Tsuen_Wan: "Tsuen Wan District",
                Tuen_Mun: "Tuen Mun District",
                Yuen_Long: "Yuen Long District",
            },

            title: "Original",
            title1: "- Funds Section, Education Bureau",
            title2: "Duplicate",
            title3: "- Respective Regional Education Office",
            title4: "[Attn :",
            title5: "Education Bureau",
            title6: "Triplicate",
            title7: "- School's Record",
            ssdo: "SSDO",
            // ssdo: "SSDO",
            schoolName: "School Name",
            contactAndTelText1: "Name of school's contact person",
            // contactAndTelText2: "and tel. no.",
            contactAndTelText3: "(for enquiry by EDB in processing this form)",
            contactPerson: "Contact Person",
            schoolCode: "School Code",
            schoolProgram: "School Session",
            schoolTel: "School Telephone No",
            nameOfTeacherInChinese: "Name of Teacher in Chinese",
            nameOfTeacherInEnglish: "Name of Teacher in English",
            hkid: "HKIC No.",
            srn: "SRN",
        },
        completedByTheSchool: {
            section: {
                section1: "Section I (to be completed by the school) ",
                section2:
                    "Section II (To be completed by the school. Please ensure that the content of this section is made known to the teacher.) ",
            },
            title: {
                a: "A. Particulars for Acting Appointment",
                b: "B. Particulars for Forfeiture of Acting Allowance",
                c: "C. Nature of Leave/Absence",
                d: "D. Qualifying Period to Acting Appointment ",
                e: "E. Recovery of Acting Allowance ",
            },
            note: {
                note1: "Leave exceeding 3 consecutive working days involves the forfeiture of acting allowance for the whole period of leave of the teachers on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays).",
                note2: "Schools are required to follow EDB Circular No. 1/2006 and its Annex “Guidelines for Granting of Leave”, No. 16/2015 (applicable to paternity leave) and No. 16/2018 (applicable to extended maternity leave) when granting leave.",
                note3: "Leave and/or absence exceeding 3 days (excluding sick leave and absence for authorised training and duty) taken by the teachers on acting appointment to eligible ranks during the acting period is not counted as part of the qualifying period.",
                note4: "A teacher who has taken up an acting appointment at eligible ranks for 30 consecutive calendar days or above is entitled to draw an acting  allowance.",
            },
            substantiveRank: "Substantive Rank",
            rankOfActingAppointment: "Rank of Acting Appointment",
            actingPeriod: "Acting Period",
            actingPeriodFrom: "From",
            actingPeriodTo: "To",
            absence: "Period of Leave/Absence",
            absenceFrom: "From",
            absenceTo: "To",
            totalDays: "Total No. of Days",
            autoGenerate: "auto-generated",
            reasonCode: "Leave/Absence Reason Code",
            nameOfTeacher: "Name of Teacher",
            srn: "SRN",
            mySchool: "With reference to Section I of this form, my school",
            note1: "I should be grateful for Education Bureau (EDB) to adjust the amount of acting allowance of the relevant teacher accordingly.",
            note2: "Leave/Absence of the teacher will / will not",
            note2a: " be counted as part of the qualifying period to attract acting allowance",
            note3: "Leave/Absence of the teacher will / will not",
            note3a: " result in non-fulfillment of the minimum qualifying period to attract acting allowance",
            termsConditions:
                "I have read, understood and agreed to the above terms and conditions.",
        },

        reasonCodeOption: {
            1: "01 Paid sick leave",
            2: "02 No-pay sick leave ",
            3: "03 Paid maternity/special tuberculosis leave",
            4: "04 No-pay maternity/special tuberculosis leave",
            5: "05 Paid paternity leave",
            6: "06 Paid study leave",
            7: "07 No-pay study leave",
            8: "08 Paid leave for juror or witness service",
            9: "09 Other type of no-pay leave  ",
            10: "10 Other type of paid leave",
        },
        schoolProgramOption: {
            am: "AM",
            pm: "PM",
            wholeDay: "Whole Day",
        },
        note2Option: {
            yes: "will",
            no: "will not",
        },
        mySchoolOption: {
            note1: "shall refund any acting allowance for the whole period of leave of the teacher on the acting appointment to eligible rank (including leave and intervening public holidays and Sundays) which ",
            note2: "shall refund the teacher’s acting allowance for the whole acting period as the leave/absence of the teacher results in non-fulfillment of the minimum qualifying period to attract acting allowance.",
            note3: "had been paid",
            note4: " to the teacher taking leave exceeding 3 consecutive working days.",
        },
        confirm: {
            signatureOfSchoolSupervisor: "Signature of School Supervisor",
            nameOfSchoolSupervisor: "Name of School Supervisor",
            schoolChop: "School Chop",
            ssdo: "SSDO",
            ssdoOption: {
                section3: "Section III ",
                section2: "Section II ",
            },
            section: {
                section3: "Section III ",
            },
            statement: "Statement",
            note: {
                note: "I have checked the completeness of Sections I and II and verified the information in accordance with the requirements of the relevant Code of Aid and EDBC No. 8/2004 “Acting Appointment and Acting Allowance”. I confirm that the information in Sections I and II of this form is correct. I have informed the above teacher of the effect of the leave/absence on the calculation of the qualifying period and the acting allowance. I also undertake my School shall refund any over-payment of Salaries Grant to the EDB.",
                note1: "Note:",
                // note2: "Leave exceeding 3 consecutive working days involves the forfeiture of acting allowance for the whole period of leave of the teachers on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays).",
                // note3: "Schools are required to follow EDB Circular No. 1/2006 and its Annex “Guidelines for Granting of Leave”, No. 16/2015 (applicable to paternity leave) and No. 16/2018 (applicable to extended maternity leave) when granting leave.",
                // note4: "Leave and/or absence exceeding 3 days (excluding sick leave and absence for authorised training and duty) taken by the teachers on acting appointment to eligible ranks during the acting period is not counted as part of the qualifying period.",
                // note5: "A teacher who has taken up an acting appointment at eligible ranks for 30 consecutive calendar days or above is entitled to draw an acting  allowance.",
            },
        },
        statement: {
            title: {
                title1: "Personal Information Collection Statement",
                title2: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s): ",
            },
            note: {
                a: "processing employment-related matters;",
                b: "processing payment of Salaries Grant and other government funding;",
                c: "calculation of provident fund contribution;",
                d: "auditing;",
                e: "conducting research and compiling statistics to facilitate planning of education services;",
                f: "processing matters relating to the development of the education profession;",
                g: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
                note1: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
                note2: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
                note3: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
                note4: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
            },
        },
        note: {
            note1: "Leave/Absence of the teacher ",
            note2: " be counted as part of the qualifying period to attract acting allowance.",
            note3: " result in non-fulfillment of the minimum qualifying period to attract acting allowance.",
        },
    },
    errorMsg: {
        schoolName: " school name",
        contactPerson: " contact person",
        schoolCode: "Please input a valid school code",
        schoolTel: "Please input a valid school telephone number",
        nameOfTeacherInChinese:
            "Please input a valid name of teacher in Chinese",
        nameOfTeacherInEnglish:
            "Please input a valid name of teacher in English",
        hkid: "Please input a valid hkid Number",
        srn: "Please input a valid SRN",
        substantiveRank: " substantive rank",
        rankOfActingAppointment: " rank of acting appointment",
        E0001: "Please enter in the correct  rules",
        E0002: "Please select the date within the term of office",
        E0003: "please select the Leave / Absence period within the Acting Period.",
        schoolTelMax: "Telephone number must be at most 12 digits",
        schoolCodeMin: "Please input the four-digit school code",
        srnMin: "Please input the eight-digit SRN",
        E0005: "The first item is required",
    },
};
export default Form065EN;
